import React, { useRef } from 'react';
import { ModalCreateUserWrapper } from 'pages/AdminRegister/styled';
import ModalCommon from 'components/Input/ModalCommon';
import { Spin } from 'antd';
import Button from 'components/Button';
import PasswordInput from 'components/Input/PasswordInput';
import TextLine from 'components/TextLine/TextLine';
import {
  isRegexFullWidthCharacter,
  isRegexSpecialCharacter,
  isRegexSpecialCharacterJP,
  isValidPassword,
} from 'helper/utils';

const ChangePassModal = ({
  infoUser,
  dataPass,
  errors,
  onConfirm,
  handleChangeDataPass,
  isOpen,
  onCancel,
}) => {
  const oldPasswordRef = useRef(null);
  const newPasswordRef = useRef(null);
  const confirmPasswordRef = useRef(null);
  return (
    <ModalCreateUserWrapper>
      <ModalCommon
        width={679}
        title="管理者の情報"
        open={isOpen}
        padding={[24, 24, 10, 24]}
        onCancel={onCancel}
        footer={
          <div className="flex h-max w-full justify-end">
            <Button
              width={120}
              height={40}
              btnType="primary"
              onClick={onConfirm}
              disabled={false}
            >
              <p style={{ letterSpacing: '0' }}>決定</p>
            </Button>
          </div>
        }
      >
        <Spin spinning={false}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 20,
              padding: '4.5px 0',
            }}
          >
            <TextLine label="名前" value={infoUser.name} />
            <TextLine label="メールアドレス" value={infoUser.email} />
            <PasswordInput
              ref={oldPasswordRef}
              label="以前のパスワード"
              required
              name="oldPassword"
              placeholder="以前のパスワード"
              widthLabel={273}
              widthInput={339}
              value={dataPass.oldPassword}
              errors={errors}
              onChange={handleChangeDataPass}
              paddingMessage={290}
              rules={[
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();
                    if (isRegexFullWidthCharacter().test(value)) {
                      return Promise.reject('半角文字で入力してください');
                    }

                    if (isRegexSpecialCharacterJP().test(value)) {
                      return Promise.reject(
                        'パスワードに特殊文字は使用できません'
                      );
                    }

                    if (!isRegexSpecialCharacter().test(value)) {
                      return Promise.reject(
                        'パスワードに特殊文字は使用できません'
                      );
                    }
                    if (!isValidPassword().test(value)) {
                      return Promise.reject(
                        'パスワードは6～14文字で入力してください'
                      );
                    }
                    return Promise.resolve();
                  },
                  validateTrigger: 'onChange',
                },
              ]}
            />

            <PasswordInput
              ref={newPasswordRef}
              label="新しいパスワード"
              required
              name="newPassword"
              widthInput={339}
              widthLabel={273}
              placeholder="新しいパスワード"
              value={dataPass.newPassword}
              errors={errors}
              onChange={handleChangeDataPass}
              rules={[
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();
                    if (isRegexFullWidthCharacter().test(value)) {
                      return Promise.reject('半角文字で入力してください');
                    }

                    if (isRegexSpecialCharacterJP().test(value)) {
                      return Promise.reject(
                        'パスワードに特殊文字は使用できません'
                      );
                    }

                    if (!isRegexSpecialCharacter().test(value)) {
                      return Promise.reject(
                        'パスワードに特殊文字は使用できません'
                      );
                    }
                    if (!isValidPassword().test(value)) {
                      return Promise.reject(
                        'パスワードは6～14文字で入力してください'
                      );
                    }
                    return Promise.resolve();
                  },
                  validateTrigger: 'onChange',
                },
              ]}
              paddingMessage={290}
            />

            <PasswordInput
              ref={confirmPasswordRef}
              label="新パスワード（確認）"
              widthInput={339}
              required
              name="confirmPassword"
              widthLabel={273}
              placeholder="新しいパスワード（確認用）"
              value={dataPass.confirmPassword}
              errors={errors}
              onChange={handleChangeDataPass}
              rules={[
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();
                    if (isRegexFullWidthCharacter().test(value)) {
                      return Promise.reject('半角文字で入力してください');
                    }

                    if (isRegexSpecialCharacterJP().test(value)) {
                      return Promise.reject(
                        'パスワードに特殊文字は使用できません'
                      );
                    }

                    if (!isRegexSpecialCharacter().test(value)) {
                      return Promise.reject(
                        'パスワードに特殊文字は使用できません'
                      );
                    }
                    if (!isValidPassword().test(value)) {
                      return Promise.reject(
                        'パスワードは6～14文字で入力してください'
                      );
                    }
                    if (value !== dataPass.newPassword) {
                      return Promise.reject('パスワードが一致しません');
                    }
                    return Promise.resolve();
                  },
                  validateTrigger: 'onChange',
                },
              ]}
              paddingMessage={290}
            />
          </div>
        </Spin>
      </ModalCommon>
    </ModalCreateUserWrapper>
  );
};

export default ChangePassModal;
